// extracted by mini-css-extract-plugin
var _1 = "ResizerHandlers_root__d21e7";
var _2 = "ResizerHandlers_visible__f433a";
export { _1 as "root", _2 as "visible" }
